<template>
  <img
    src="/logo.png"
    alt="Hack Club Signatures"
    height="40"
    width="40"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
